export const styles = {
  container: {
    marginBottom: "20px",
  },
  label: {
    color: "text.primary",
    "& .MuiFormControlLabel-label": {
      paddingRight: "0.5rem",
    },
  },
};
